import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import DealForm from 'bundles/apex/deals/form';
import Deals from './deals';
import Header from './header';
import LoadingSpinner from 'components/loading_spinner';
import SuccessModal from './creation/modal/success';

import { addDeal } from 'bundles/project/actions/deals';

export function DealsTab({ addDeal, deals, features, formProps, paths, stagesConfig }) {
  const [createdDeal, setCreatedDeal] = useState();
  const [newDeal, setNewDeal] = useState();
  const [newDealListing, setNewDealListing] = useState();

  if (!deals) {
    return <LoadingSpinner/>;
  }

  function onNewDeal(deal, listing) {
    const stageConfig = stagesConfig[deal.stage];
    let defaults = {};
    if (stageConfig?.defaultCloseProbability) {
      defaults = { closeProbability: stageConfig.defaultCloseProbability };
    }
    setNewDeal({ ...deal, ...defaults });
    setNewDealListing(listing);
  }

  function saveDeal(deal) {
    setNewDeal(null);
    setCreatedDeal(deal);
    addDeal(deal);
  }

  return <React.Fragment>
    {newDeal ? null : <>
      <Header path={paths.new} onNewDeal={onNewDeal} />
      <Deals deals={deals} features={features} />
    </>}

    {!newDeal ? null :
      <div className="mb-12"> { /* To leave scroll room for the intercom widget */ }
        <DealForm
          {...formProps}
          allowTypeChange={false}
          deal={newDeal}
          features={features}
          stagesConfig={stagesConfig}
          onCancel={() => setNewDeal(null)}
          onSave={saveDeal}
        />
      </div>
    }

    {!createdDeal ? null :
      <SuccessModal
        deal={createdDeal}
        listing={newDealListing}
        onClose={() => setCreatedDeal(null)}
      />
    }
  </React.Fragment>;
}

DealsTab.propTypes = {
  addDeal: PropTypes.func.isRequired,
  deals: PropTypes.array,
  features: PropTypes.object,
  formProps: PropTypes.object.isRequired,
  paths: PropTypes.shape({
    new: PropTypes.string.isRequired,
  }).isRequired,
  stagesConfig: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  deals: state.deals,
  stagesConfig: state.apexDealStagesConfig,
});

const mapDispatchToProps = {
  addDeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealsTab);
